// components/common/DefinitionListCard.tsx

import { Card, CardHeader, Divider, CardContent, Grid, Typography, GridSize } from "@material-ui/core";


export interface DefinitionItem {
  label: string;
  value: React.ReactNode;
}

interface DefinitionListCardProps {
  title: string;
  items: DefinitionItem[];
  columns?: 1 | 2 | 3 | 4; // 🔒 constrained
}

export const DefinitionListCard: React.FC<DefinitionListCardProps> = ({
  title,
  items,
  columns = 2,
}) => {
  const mdSize = (12 / columns) as GridSize; // ✅ safe cast

  return (
    <Card variant="outlined">
      <CardHeader title={title} />
      <Divider />
      <CardContent>
        <Grid container spacing={2}>
          {items.map((item) => (
            <Grid item xs={12} md={mdSize} key={item.label}>
              <Typography
                variant="caption"
                color="secondary"
                display="block"
              >
                {item.label}
              </Typography>
              <Typography style={{fontWeight:500}}>
                {item.value ?? "-"}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};
